// extracted by mini-css-extract-plugin
module.exports = {"agreement":"style__agreement__KDlPV","nasnTerms":"style__nasnTerms__gIgMZ","terms":"style__terms__5KqUY"};